var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D165692E-C318-4DCA-A0D0-324C37F1E97F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Sub-Category-Notes",
    transform: "translate(-1234.000000, -161.000000)",
    fill: "#113982",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red-flag",
    transform: "translate(1234.913630, 161.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63989258,0 C6.57202324,0 5.78921572,0.434508838 5.03214258,0.854729736 C4.3338832,1.24230015 3.67433262,1.60839844 2.81469727,1.60839844 C2.00208076,1.60839844 1.16252358,1.18458545 0.804199219,0.979755908 L0.804199219,0 L0,0 L0,13.725 L0.804199219,13.725 L0.804199219,8.32228242 C1.30760112,8.56536504 2.05379077,8.84619141 2.81469727,8.84619141 C3.88253979,8.84619141 4.66540093,8.41168257 5.42244727,7.99146167 C6.12070664,7.60389126 6.78028403,7.23779297 7.63989258,7.23779297 C8.70601948,7.23779297 9.81873633,7.9673625 9.82945898,7.97446626 L10.4545898,8.3912291 L10.4545898,0.991095117 C9.62773901,0.445419141 8.61854941,0 7.63989258,0 Z M9.65039062,6.95747593 C9.14698872,6.71439331 8.40079907,6.43359375 7.63989258,6.43359375 C6.57202324,6.43359375 5.78921572,6.86810259 5.03214258,7.28832349 C4.3338832,7.6758939 3.67433262,8.04199219 2.81469727,8.04199219 C2.00194673,8.04199219 1.16222871,7.61804517 0.804199219,7.41337646 L0.804199219,1.88868867 C1.30760112,2.13177129 2.05379077,2.41259766 2.81469727,2.41259766 C3.88253979,2.41259766 4.66540093,1.97808882 5.42244727,1.55786792 C6.12070664,1.17029751 6.78028403,0.804199219 7.63989258,0.804199219 C8.4525627,0.804199219 9.29233433,1.22811943 9.65039062,1.43281494 L9.65039062,6.95747593 Z",
    id: "_x3C_Group_x3E__7_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPlane);
export default __webpack_public_path__ + "static/media/flagPlane.cae8b6d7143d3bc9aeb93664b8989e11.svg";
export { ForwardRef as ReactComponent };